<template>
  <div>
    <div class="b-personal-container">
      <div class="b-personal-container-poi-col">
        <div class="b-personal-container__user-details">
          <h3>User details</h3>

          <div>
            <div class="b-personal-container__user-details__data-row">
              <div class="b-personal-container__user-details__data">
                <div class="b-personal-container__user-details__row-heading">Full Name</div>
                <br />
                <div v-if="edit.fullname">
                  <input
                    type="text"
                    :value="details.fullname"
                    class="b-personal-container__user-details__data-edit"
                    @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'fullname'})"
                    @blur="edit.fullname=false"
                  />
                </div>
                <div
                  v-else
                  v-on:dblclick="changeCKycDetailHandler('fullname',$event)"
                  class="b-personal-container__user-details__text"
                  :style="{'cursor': getCKycStatusForApproval ? 'pointer': 'auto'}"
                >{{details.fullname}}</div>
              </div>
              <div class="b-personal-container__user-details__data">
                <div class="b-personal-container__user-details__row-heading">PAN Number</div>
                <br />

                <div v-if="edit.pan_number">
                  <input
                    type="text"
                    :value="details.pan_number"
                    class="b-personal-container__user-details__data-edit"
                    @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'pan_number'})"
                    @blur="edit.pan_number=false"
                  />
                </div>
                <div
                  v-else
                  v-on:dblclick="changeCKycDetailHandler('pan_number',$event)"
                  class="b-personal-container__user-details__text"
                  :style="{'cursor': getCKycStatusForApproval ? 'pointer': 'auto'}"
                >{{details.pan_number}}</div>
              </div>
            </div>

            <div class="b-personal-container__user-details__data-row">
              <div class="b-personal-container__user-details__data">
                <div class="b-personal-container__user-details__row-heading">Gender</div>
                <br />

                <div v-if="edit.gender">
                  <select
                    :value="details.gender"
                    @blur="edit.gender=false"
                    @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'gender'})"
                  >
                    <option value="M">Male</option>
                    <option value="F">Female</option>
                  </select>
                </div>
                <div
                  v-else
                  v-on:dblclick="changeCKycDetailHandler('gender',$event)"
                  class="b-personal-container__user-details__text"
                  :style="{'cursor': getCKycStatusForApproval ? 'pointer': 'auto'}"
                >{{details.gender}}</div>
              </div>
              <div class="b-personal-container__user-details__data">
                <div>DOB</div>
                <br />

                <div v-if="edit.date_of_birth">
                  <input
                    type="date"
                    class="b-personal-container__user-details__data-edit"
                    @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'date_of_birth'})"
                    @blur="edit.date_of_birth=false"
                    :value="details.date_of_birth"
                  />
                   <!-- <DatePicker
                    format="dd MMM yyyy"
                    input-class="b-personal-container__user-details__data-edit"
                    placeholder="Select DOB"
                    @selected="updateDate"
                    @closed="edit.date_of_birth=false"
                    :value="details.date_of_birth"
                    :clear-button="true"
                    clear-button-icon="fa fa-times-circle"
                    /> -->
                </div>
                <div
                  v-else
                  v-on:dblclick="changeCKycDetailHandler('date_of_birth',$event)"
                  class="b-personal-container__user-details__text"
                  :style="{'cursor': getCKycStatusForApproval? 'pointer': 'auto'}"
                >{{details.date_of_birth && customFormatter(details.date_of_birth)}}</div>
              </div>
            </div>

            <div class="b-personal-container__user-details__data-row">
              <div class="b-personal-container__user-details__data">
                <div class="b-personal-container__user-details__row-heading">Father's Name</div>
                <br />

                <div v-if="edit.father_fullname">
                  <input
                    type="text"
                    :value="details.father_fullname"
                    class="b-personal-container__user-details__data-edit"
                    @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'father_fullname'})"
                    @blur="edit.father_fullname=false"
                  />
                </div>
                <div
                  v-else
                  v-on:dblclick="changeCKycDetailHandler('father_fullname',$event)"
                  class="b-personal-container__user-details__text"
                  :style="{'cursor': getCKycStatusForApproval? 'pointer': 'auto'}"
                >{{details.father_fullname}}</div>
              </div>
              <div class="b-personal-container__user-details__data">
                <div class="b-personal-container__user-details__row-heading">Mother's Name</div>
                <br />

                <div v-if="edit.mother_fullname">
                  <input
                    type="text"
                    :value="details.mother_fullname"
                    class="b-personal-container__user-details__data-edit"
                    @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'mother_fullname'})"
                    @blur="edit.mother_fullname=false"
                  />
                </div>
                <div
                  v-else
                  v-on:dblclick="changeCKycDetailHandler('mother_fullname',$event)"
                  class="b-personal-container__user-details__text"
                  :style="{'cursor': getCKycStatusForApproval? 'pointer': 'auto'}"
                >{{details.mother_fullname}}</div>
              </div>
            </div>
            <div class="b-personal-container__user-details__data-row">
              <div class="b-personal-container__user-details__data">
                <div class="b-personal-container__user-details__row-heading">Email</div>
                <br />

                <div v-if="edit.email">
                  <input
                    type="text"
                    :value="details.email"
                    class="b-personal-container__user-details__data-edit"
                    @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'email'})"
                    @blur="edit.email=false"
                  />
                </div>
                <div
                  v-else
                  v-on:dblclick="changeCKycDetailHandler('email',$event)"
                  class="b-personal-container__user-details__text"
                  :style="{'cursor': getCKycStatusForApproval? 'pointer': 'auto'}"
                >{{details.email}}</div>
              </div>
              <div class="b-personal-container__user-details__data">
                <div class="b-personal-container__user-details__row-heading">Mobile Phone</div>
                <br />

                <div v-if="edit.mobile_number">
                  <input
                    type="text"
                    :value="details.mobile_number"
                    class="b-personal-container__user-details__data-edit"
                    @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'mobile_number'})"
                    @blur="edit.mobile_number=false"
                  />
                </div>
                <div
                  v-else
                  v-on:dblclick="changeCKycDetailHandler('mobile_number',$event)"
                  class="b-personal-container__user-details__text"
                  :style="{'cursor': getCKycStatusForApproval? 'pointer': 'auto'}"
                >{{details.mobile_number}}</div>
              </div>
            </div>
            <div class="b-personal-container__user-details__data-row">
              <!-- <div class="b-personal-container__user-details__data">
                <div class="b-personal-container__user-details__row-heading">Martial Status</div>
                <br />
                <div v-if="edit.marital_status">
                  <select
                    :value="details.marital_status"
                    @blur="edit.marital_status=false"
                    @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'marital_status'})"
                  >
                    <option value="Married">Married</option>
                    <option value="Unmarried">Unmarried</option>
                  </select>
                </div>
                <div
                  v-else
                  v-on:dblclick="changeCKycDetailHandler('marital_status',$event)"
                  class="b-personal-container__user-details__text"
                  :style="{'cursor': getCKycStatusForApproval? 'pointer': 'auto'}"
                >{{details.marital_status}}</div>
              </div> -->
              <!-- <div class="b-personal-container__user-details__data">
                <div class="b-personal-container__user-details__row-heading">Nationality</div>
                <br />
                <div v-if="edit.corres_country">
                  <select
                    :value="details.corres_country"
                    @blur="edit.corres_country=false"
                    @change="$store.commit('updateCKycDetail',{value: $event.target.value,key:'corres_country'})"
                  >
                    <option
                      v-for="country in countries"
                      :value="country"
                      :key="country"
                    >{{ country }}</option>
                  </select>
                </div>
                <div
                  v-else
                  v-on:dblclick="changeCKycDetailHandler('corres_country',$event)"
                  class="b-personal-container__user-details__text"
                  :style="{'cursor': getCKycStatusForApproval? 'pointer': 'auto'}"
                >{{details.corres_country}}</div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="b-personal-container__form" v-if="getCKycStatusForApproval">
          <!-- <div class="b-personal-container__form_row">
            <input
              type="checkbox"
              id="pan"
              value="pan"
              :checked="checkDetails['pan_status']"
              @change="$emit('checkDetail', 'pan_status')"
            />
            <label for="pan">PAN number as per PAN</label>
            <br />
          </div> -->
          <div class="b-personal-container__form_row">
            <input
              type="checkbox"
              id="name"
              value="name"
              :checked="checkDetails['name']"
              @change="$emit('checkDetail', 'name')"
            />
            <label for="name">Name as per PAN/ Address Proof</label>
            <br />
          </div>
          <div class="b-personal-container__form_row">
            <input
              type="checkbox"
              id="dob"
              value="dob"
              :checked="checkDetails['dob']"
              @change="$emit('checkDetail', 'dob')"
            />
            <label for="dob">DOB as per PAN / Address Proof</label>
            <br />
          </div>

          <!-- <div class="b-personal-container__form_row">
            <input
              type="checkbox"
              id="signature"
              value="signature"
              :checked="checkDetails['signature']"
              @change="$emit('checkDetail', 'signature')"
            />
            <label for="signature">Signature matches as per the PAN</label>
            <br />
          </div> -->
        </div>
        <div class="b-personal-container__btn">
          <div v-if="editFlag">
            <button class="b-global__button" @click="updateInfo">Save Changes</button>
          </div>
          <button @click="checkEditDetails();" class="b-global__button">NEXT</button>
          <div v-if="showModal">
            <Modal @closeModal="showModal= false" @goNext="$emit('goNext') "></Modal>
          </div>
        </div>
      </div>
      <div class="b-personal-container-poi-col">
        <h3>User Proof</h3>
   
      
        <div class="b-personal-container__img">
          <!-- <img v-bind:src="details.url_poi_side1" alt="Proof of address" style="width:100%" /> -->
            <iframe
                v-bind:src="details.url_poi_side1"
                frameborder="0"
                style="width:350px; height:400px;"
            >
            </iframe>
          <div class="b-personal-container__img-section">
            <p>PAN Image</p>
            <div class="b-personal-container__btn-container" v-if="getCKycStatusForApproval">
              <div>
                <button
                  @click="rotateImage('url_poi_side1')"
                  class="b-global__button b-personal-container__edit-btn"
                >EDIT</button>
              </div>
              <div class="b-personal-container__upload">
                <input
                  type="file"
                  @change="handleUploadFile('url_poi_side1',$event)"
                  accept="image/*"
                  class="b-personal-container__upload-input"
                />
                <img class="b-personal-container__upload-img" src="../../assets/upload.png" />
                <span class="b-perosnal-conatiner__upload-text">Upload</span>
              </div>            
            </div>
            <div >
                <p>Size</p>
                {{getFileSize(details.url_poi_side1)}}
            </div>              
          </div>
        </div>

        <div class="b-personal-container__img">
          <!-- <img v-bind:src="details.file_signature" alt="Signature" style="width:100%" /> -->
            <iframe
                v-bind:src="details.file_signature"
                frameborder="0"
                style="width:350px; height:400px;"
            >
            </iframe>          
          <div class="b-personal-container__img-section">
            <p>Signature Image</p>
            <div class="b-personal-container__btn-container" v-if="getCKycStatusForApproval">
              <div>
                <button
                  @click="rotateImage('file_signature')"
                  class="b-global__button b-personal-container__edit-btn"
                >EDIT</button>
              </div>
              <div class="b-personal-container__upload">
                <input
                  type="file"
                  @change="handleUploadFile('file_signature',$event)"
                  accept="image/*"
                  class="b-personal-container__upload-input"
                />
                <img class="b-personal-container__upload-img" src="../../assets/upload.png" />
                <span class="b-perosnal-conatiner__upload-text">Upload</span>
              </div>
            </div>
              <div>
                   <p>Size</p>
                  {{getFileSize(details.file_signature)}}
              </div>
          </div>
        </div>
          <div class="b-personal-container__img">
          <!-- <img v-bind:src="details.url_photo" alt="User image" style="width:100%" /> -->
            <iframe
                v-bind:src="details.url_photo"
                frameborder="0"
                style="width:350px; height:400px;"
            >
            </iframe>           
          <div class="b-personal-container__img-section">
            <p>Profile Image</p>
            <div class="b-personal-container__btn-container" v-if="getCKycStatusForApproval">
              <div>
                <button
                  @click="rotateImage('url_photo')"
                  class="b-global__button b-personal-container__edit-btn"
                >EDIT</button>
              </div>
              <div class="b-personal-container__upload">
                <input
                  type="file"
                  @change="handleUploadFile('url_photo',$event)"
                  accept="image/*"
                  class="b-personal-container__upload-input"
                />
                <img class="b-personal-container__upload-img" src="../../assets/upload.png" />
                <span class="b-perosnal-conatiner__upload-text">Upload</span>
              </div>
            </div>
                            <div >
                   <p>Size</p>
                  {{getFileSize(details.url_photo)}}
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import Modal from "../../commons/modal-ckyc.vue";
import countries from "../../commons/countries.json";
import moment from "moment";
import axios from "axios";
import Vue from "vue"
import { mapGetters } from "vuex";

export default {
  components: { Modal },
  data() {
    return {
      edit: {
        name: false,
        father_fullname: false,
        mother_fullname: false,
        pan_number: false,
        date_of_birth: false,
        residence_status: false,
        gender: false,
        marital_status: false,
        nationality: false,
        email: false,
        mobile_number: false,
        corres_country: false
      },

      showModal: false,
      countries: countries.countries
    };
  },
  props: {
    checkDetails: {
      type: Object
    },

    details: {
      type: Object,
      required: true
    },
    editFlag: {
      type: Boolean
    }
  },

  computed: {
    ...mapGetters(["getCKycStatusForApproval","getCkycDetails"]),
  },

  methods: {
    // async handleConsentUpload (evt) {
    //   const file = evt.target.files[0]

    //   const formData = new FormData()
    //   formData.append("attachment", file)
    //   formData.append("type", file.type)

    //   try {
    //     // UPLOAD FILE
    //     const fileUploadResponse = await axios.post(`${Vue.config.EL_DORADO_API_URL}/api/v3/file_upload.json`, formData)
    //     const fileUrl = fileUploadResponse.data.file_url

    //     // UPDATE URL TO CVL DATA ON DB
    //     const ckycId = this.$route.params.id
    //     let cvlData = JSON.parse(JSON.stringify(this.$store.state.ckycDetails.copyUserCKycData))
    //     cvlData = {
    //       ...cvlData,
    //       ckyc_audit: {
    //         personal: {
    //           pan_status: "",
    //           name: ""
    //         },
    //         ipv: {
    //           gender: "",
    //           video: "",
    //           url_kyc_consent_form: fileUrl
    //         },
    //         address: {
    //           address_status: ""
    //         },
    //         kyc: {}
    //       }
    //     }
    //     cvlData.url_kyc_consent_form = fileUrl
    //     await axios.put(`${Vue.config.EL_DORADO_API_URL}/admin/adfes433fkdfggs343434/ckyc/${ckycId}.json`, { cvl: cvlData })

    //     // // UPDATE DATE ON PAGE
    //     // this.$store.commit('updateCKycDetail', { key: 'url_kyc_consent_form', value: fileUrl })

    //     // SUCCESS MSG
    //     this.$store.commit("SHOW_NOTIFICATION", {
    //       showNotification: true,
    //       message: "Success !",
    //       succesFlag: true
    //     })
    //   } catch (e) {
    //     this.$store.commit("SHOW_NOTIFICATION", {
    //       showNotification: true,
    //       message: "Failed: " + e.message,
    //       succesFlag: false
    //     })
    //   }
    // },

    checkDetail: function(element) {
      let array = ["Personal", element];
      this.$emit("checkDetail", array);
    },
    handleUploadFile: function(key, evt) {
      let files = evt.target.files || evt.dataTransfer.files;
      this.$store.dispatch("uploadFileCkyc", {
        file: files[0],
        id: this.$route.params.id,
        key: key
      });
    },
    showEditHandler(value) {
      this.edit[value] = !this.edit[value];
    },
    updateInfo() {
      let obj = {};
      obj.data = this.$store.state.ckycDetails.userCkycData;
      obj.id = this.$route.params.id;
      if (obj.data.hasOwnProperty("error_message"))
        delete obj.data.error_message;
      this.$store.dispatch("updateCKycDetail", obj);
      this.$emit("changeEditFlag", false);
    },
    changeCKycDetailHandler(editInfo, event) {
      if (this.getCKycStatusForApproval) {
        this.edit[editInfo] = !this.edit[editInfo];
        this.$emit("changeEditFlag", true);
      } else {
        event.preventDefault();
      }
    },
    checkEditDetails() {
      if (this.editFlag) this.showModal = true;
      else this.$emit("goNext");
    },
    rotateImage(element) {
        let element_param = element + '_image'
        let images_required = true
        this.$store.dispatch("ckycDetailsByID", { id: this.$route.params.id, images_required: element } ).then(() => {  
            this.$store.commit("setcroppedImgUrl", this.getCkycDetails[element_param]);
            this.$router.push({
                name: "ckyc-details-edit-img",
                params: {
                id: this.$route.params.id,
                imgname: element
                }
            });
        })
    },
    updateDate(date){
      this.$store.commit('updateCKycDetail',{value: moment(date).format("DD/MM/YYYY"),key:'date_of_birth'});
    },
     customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    getFileSize(url)
    {
        var fileSize = '';
        var http = new XMLHttpRequest();
        http.open('HEAD', url, false); // false = Synchronous

        http.send(null); // it will stop here until this http request is complete

        // when we are here, we already have a response, b/c we used Synchronous XHR

        if (http.status === 200) {
            fileSize = http.getResponseHeader('content-length');
            console.log('fileSize = ' + fileSize);
        }

        return this.formatSizeUnits(fileSize);
    },

    formatSizeUnits(bytes){
        if      (bytes >= 1073741824) { bytes = (bytes / 1073741824).toFixed(2) + " GB"; }
        else if (bytes >= 1048576)    { bytes = (bytes / 1048576).toFixed(2) + " MB"; }
        else if (bytes >= 1024)       { bytes = (bytes / 1024).toFixed(2) + " KB"; }
        else if (bytes > 1)           { bytes = bytes + " bytes"; }
        else if (bytes == 1)          { bytes = bytes + " byte"; }
        else                          { bytes = "0 bytes"; }
        return bytes;
    }
  }
};
</script>

<style scoped>
.b-personal-container {
  margin-top: 40px;
  display: flex;

  justify-content: center;
}
.b-personal-container__img {
  width: 358px;
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  border: solid 1px #e0e0e0;
  margin-bottom: 25px;
}
.b-personal-container__form {
  width: 328px;
  border-radius: 8px;
  border: solid 1px #e0e0e0;
  background-color: #ffffff;
  margin: 15px;
}
.b-personal-container__error {
  color: #d8000c;
}
.b-personal-container__form button {
  margin-top: 15px;
}
.b-personal-container__form label {
  margin-left: 10px;
}
.b-personal-container__img-label {
  margin-top: 10px;
  padding-left: 108px;
  font-weight: 600px;
}
.b-personal-container__form_row {
  border-bottom: solid 1px #e0e0e0;
  padding: 10px;
}
.b-personal-container__user-details {
  min-width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.b-personal-container-poi-col {
  display: flex;
  flex-direction: column;

  margin: 30px;
}
.b-personal-container-poi-col h3 {
  text-align: center;
}

.b-personal-container__user-details {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.b-personal-container__user-details__column {
  display: flex;
  flex-direction: column;
  margin-top: 15px;
}
.b-personal-container__user-details__row {
  display: flex;
  background: #f4f7f8;
}
.b-personal-container__user-details__row-data {
  max-width: 225px;
  display: flex;
}
.b-personal-container__btn-container {
  display: flex;
  justify-content: space-evenly;
}
.edit,
.save {
  width: 15px;
  height: 16px;
  object-fit: contain;
}
.b-personal-container__user-details__edit {
  display: flex;
}
.b-personal-container__user-details__data {
  padding: 10px;
  width: 328px;
  margin: 10px;
  border-radius: 4px;
  border: solid 1px #e0e0e0;
  background-color: #ffffff;
}

.b-personal-container__user-details__data-edit {
  width: 90%;
  font-size: 16px;
  padding: 4px;
}
.b-personal-container__user-details__row-heading {
  min-width: 265px;
  font-weight: 600;
}

.b-personal-container__user-details__data label {
  margin: 15px;
  padding-top: 10px;
}
/* .b-personal-container__user-details__data input {
  border: none;
  padding: 4px
} */
.b-personal-container__user-details__data select {
  border: none;
  background: none;
  font-size: 16px;

  width: 100%;
}
.b-personal-container__btn {
  display: flex;
  justify-content: center;
}

.b-personal-container__img-section {
  text-align: center;
}
.b-perosnal-conatiner__upload {
  width: 14px;
  height: 14px;
  object-fit: contain;
}
.b-perosnal-conatiner__upload-text {
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  padding-left: 10px;
  letter-spacing: normal;
  text-align: center;
  color: #00bfff;
}
.b-personal-container__user-details__data-row {
  display: flex;
}
.b-personal-container__upload {
  cursor: pointer;
  position: relative;
  margin-top: 13px;
}
.b-personal-container__upload-input {
  -webkit-appearance: none;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.b-personal-container__user-details__text {
  height: 18px;
}
.b-personal-container__edit-btn {
  margin: unset !important;
}
</style>